@if (incomeTaxEntity$ | async; as incomeTaxEntity) {
  <form [formGroup]="formGroup">
    @if (kostenGehandicaptKind.length > 0) {
      <div formArrayName="kostenGehandicaptKind">
        @for (item of kostenGehandicaptKind.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Voorletter(s) en achternaam' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="naam"
                                            id="naam"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-date-form-control [label]="i === 0 ? 'Geboortedatum' : ''"
                                            [required]=true
                                            class="col-auto custom-input-150"
                                            formControlName="geboortedatumKind"
                                            id="geboortedatumKind"
                                            placeholder="dd-mm-jjjj"
            >
            </snelstart-ui-date-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Dagen verzorging p/j' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="dagenVerzorging"
                                              id="dagenVerzorging"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Dagen gereisd p/j' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="dagenGereisd"
                                              id="dagenGereisd"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Km\'s enkele reis' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="afstandEnkeleReis"
                                              id="afstandEnkeleReis"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Ontvangen vergoeding' : ''"
                                              align="right"
                                              class="col-auto custom-input-175"
                                              formControlName="vergoeding"
                                              id="vergoeding"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Weekenduitgaven
  </snelstart-ui-button>

  @if (hasKindJongerDan21()) {
    <div class="space20"></div>
    <snelstart-ui-alert type="warning">
      Let op: De aftrekpost 'Weekenduitgaven gehandicapte kinderen' is alleen voor kinderen die in het
      aangiftejaar {{ incomeTaxEntity.aangifte?.aangifteJaar }} 21 jaar of ouder zijn.
    </snelstart-ui-alert>
  }

}






